var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report_tc"},[_c('img',{attrs:{"src":_vm.img_url +_vm.material.pc_jb_ts}})])}
var staticRenderFns = []

export { render, staticRenderFns }